module.exports = __webpack_public_path__ + "img/76153.699429bc.svg";